
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Chart from 'chart.js/auto';

import { sharedState } from '../../../../framework/state';

import { CustomerReportVehicleTypeRow } from '../../../../../common/application/model/report/CustomerReportVehicleTypeRow';

@Component
export default class VehicleStates extends Vue {
    @Prop(Array) readonly rows!: CustomerReportVehicleTypeRow[];

    shared = sharedState;

    local = {
        stateChart: undefined as Chart | undefined,
    };

    mounted() {}

    @Watch('rows')
    rowsChanged() {
        if (this.local.stateChart && this.local.stateChart.data && this.local.stateChart.data.datasets) {
            this.local.stateChart.data.datasets[0].data = this.chartData;
            this.local.stateChart.update();
        }
    }

    private get chartData(): number[] {
        return [
            this.rows.map((r) => r.acquisition).reduce((a, b) => a + b, 0),
            this.rows.map((r) => r.active).reduce((a, b) => a + b, 0),
            this.rows.map((r) => r.ending).reduce((a, b) => a + b, 0),
            this.rows.map((r) => r.realization).reduce((a, b) => a + b, 0),
            this.rows.map((r) => r.inactive).reduce((a, b) => a + b, 0),
        ];
    }
}
